import { EmailDiscover } from '@/components';
import { useState } from 'react';
import Confetti from 'react-confetti';
import classes from './App.module.css';

export const App = () => {
  const [emailDiscovered, setEmailDiscovered] = useState(false);

  const handleEmailDiscover = () => {
    setEmailDiscovered(true);
  };

  return (
    <div className={classes.container}>
      <EmailDiscover onEmailDiscover={handleEmailDiscover} />
      <Confetti
        gravity={0.05}
        numberOfPieces={250}
        opacity={0.5}
        run={emailDiscovered}
        style={{ zIndex: -1 }}
      />
    </div>
  );
};
